import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

const hotWords = ["逆光飞行", "星际回响", "长夜灯火", "欢乐大玩家", "悬疑"];

export default function SearchBand() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const submit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : "/search");
  };

  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            想看什么？在这里搜索
          </h2>
          <p className="mt-1.5 text-sm text-foreground-500">
            支持片名、主演、类型的模糊搜索，快速定位你想看的影视内容
          </p>
        </div>
        <form onSubmit={submit} className="flex w-full items-center gap-2 md:w-auto">
          <div className="flex flex-1 items-center gap-2 rounded-full border border-background-200 bg-background-100 px-4 py-2.5 md:w-72">
            <i className="ri-search-line text-base text-foreground-400" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="输入片名 / 主演 / 类型"
              className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
          </div>
          <button
            type="submit"
            className="cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            搜索
          </button>
        </form>
      </div>
      <div className="mt-4 flex flex-wrap items-center gap-2">
        <span className="text-xs text-foreground-400">热门搜索：</span>
        {hotWords.map((word) => (
          <button
            key={word}
            type="button"
            onClick={() => navigate(`/search?q=${encodeURIComponent(word)}`)}
            className="cursor-pointer rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-800 transition-colors hover:bg-secondary-200"
          >
            {word}
          </button>
        ))}
      </div>
    </section>
  );
}